import { flags, permissions } from './constants';
import { useFeatureAccess } from './use-feature-access';

/**
 * Determines if the user has access to Bulk Email.
 *
 * This is a convenience hook that wraps `useFeatureAccess` and checks
 * both feature flags and ACL permissions for Bulk Email.
 *
 * @returns An object containing access information for Bulk Email features:
 * - `hasBulkEmailAccess`: The user has ACL permissions and the flag is enabled for Bulk Email
 * - `hasBulkEmailFlagEnabled`: The Bulk Email feature flag is enabled for at least one location
 * - `locationsWithBulkEmailAccess`: Location IDs where the user has the ACL and Bulk Email is enabled
 * - `locationsWithBulkEmailEnabled`: Location IDs where the Bulk Email feature flag is enabled
 */
export const useHasBulkEmailAccess = () => {
  const {
    hasAccess: hasBulkEmailAccess,
    hasEnabledFlag: hasBulkEmailFlagEnabled,
    locationsWithACLAccess: locationsWithBulkEmailAccess,
    locationsWithEnabledFlag: locationsWithBulkEmailEnabled,
  } = useFeatureAccess(flags.emailMarketing, permissions.emailMarketing);

  return {
    hasBulkEmailAccess,
    hasBulkEmailFlagEnabled,
    locationsWithBulkEmailAccess,
    locationsWithBulkEmailEnabled,
  };
};
